import React from 'react';
import '../../css/ModalAlert.css';

const ModalConfirm = ({ show, onClose, title, children }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        {/* <div className="modal-header">
          <h4 className="modal-title">{title}</h4>
        </div> */}
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
